import { defineStore } from 'pinia'

function getDomainLanguage() {
  switch (window.location.hostname) {
    case 'lohnrechner.ch':
      return 'de-ch'
    case 'calculateur-salarial.ch':
      return 'fr-ch'
    case 'calcolare-salario.ch':
      return 'it-ch'
    default:
      return 'de-ch'
  }
}

export const useTextStore = defineStore('texts', {
  state: () => ({
    language: getDomainLanguage(),
    texts: {},
    loading: true
  })
})

export function toUnderscore(str) {
  // de-ch -> de_CH
  let parts = str.split('-')
  return parts[0] + '_' + parts[1].toUpperCase()
}

export function toDash(str) {
  // de_CH -> de-ch
  let parts = str.split('_')
  return parts[0] + '-' + parts[1].toLowerCase()
}

export function toPrefix(str) {
  if (str.includes('-')) {
    return str.split('-')[0]
  }
  return str.split('_')[0]
}

// Texte, die im CMS (noch) nicht gepflegt sind. `t()` gibt den Schlüssel zurück,
// wenn er unbekannt ist — dann greifen wir auf diese Fallbacks zurück.
const LOCAL_FALLBACKS = {
  'lohnentwicklung-loading': {
    de: 'Lohnentwicklung wird berechnet...',
    fr: 'Calcul de l’évolution des salaires...',
    it: 'Calcolo dell’evoluzione dei salari...'
  },
  'keine-prognose-verfuegbar': {
    de: 'Für dieses Profil ist leider keine Lohnberechnung verfügbar.',
    fr: 'Aucun calcul de salaire n’est malheureusement disponible pour ce profil.',
    it: 'Purtroppo per questo profilo non è disponibile alcun calcolo salariale.'
  },
  'keine-lohnentwicklung-verfuegbar': {
    de: 'Für dieses Profil ist leider keine Lohnentwicklung verfügbar.',
    fr: 'Aucune évolution salariale n’est malheureusement disponible pour ce profil.',
    it: 'Purtroppo per questo profilo non è disponibile alcuna evoluzione salariale.'
  },
  'mindestlohn-nicht-berechenbar': {
    de: 'Der Mindestlohn konnte für diese Angaben leider nicht berechnet werden. Die Angaben zu deinem Gesamtarbeitsvertrag findest du hier:',
    fr: 'Le salaire minimum n’a malheureusement pas pu être calculé pour ces données. Tu trouveras les informations sur ta convention collective ici:',
    it: 'Purtroppo non è stato possibile calcolare il salario minimo per questi dati. Trovi le informazioni sul tuo contratto collettivo qui:'
  },
  'branche-keine-treffer': {
    de: 'Keine passende Branche gefunden.',
    fr: 'Aucune branche correspondante trouvée.',
    it: 'Nessun settore corrispondente trovato.'
  }
}

// Übersetzung mit hartkodiertem Fallback, solange der Schlüssel nicht im CMS ist.
export function translate(t, key) {
  const translated = t(key)
  if (translated && translated !== key) {
    return translated
  }
  const fallback = LOCAL_FALLBACKS[key]
  if (!fallback) {
    return translated
  }
  const lang = document.documentElement.lang || 'de-ch'
  if (lang.startsWith('fr')) return fallback.fr
  if (lang.startsWith('it')) return fallback.it
  return fallback.de
}
